/**
 * Formats a string for last name (without event)
 * Useful for formatting existing values
 * @param {string} value - The value to format
 * @returns {string} The value in uppercase
 */
export const formatLastnameValue = (value) => {
    return (value || '').toUpperCase()
}

/**
 * Formats a string for first name (without event)
 * Useful for formatting existing values
 * @param {string} value - The value to format
 * @returns {string} The formatted value
 */
export const formatFirstnameValue = (value) => {
    return (value || '')
        .split(/(\s+|-|')/g)
        .map((word) => {
            if (word.match(/^\s+$/) || word === '-' || word === '\'') {
                return word
            }
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            }
            return word
        })
        .join('')
}

/**
 * Formats a string for position (without event)
 * Useful for formatting existing values
 * @param {string} value - The value to format
 * @returns {string} The formatted value
 */
export const formatPositionValue = (value) => {
    const str = (value || '').toLowerCase()
    return str?.[0]?.toUpperCase() || '' + str?.slice(1) || ''
}

/**
 * Formats the last name to uppercase
 * @param {Event} event - The input event
 * @param {Function} setValue - Function to update the value (e.g., (val) => form.value.lastname = val)
 */
export const formatLastname = (event, setValue) => {
    const input = event.target
    const cursorPosition = input.selectionStart
    const newValue = formatLastnameValue(input.value)

    setValue(newValue)

    // Restore cursor position
    setTimeout(() => {
        input.setSelectionRange(cursorPosition, cursorPosition)
    }, 0)
}

/**
 * Formats the first name with the first letter of each word capitalized
 * Handles words separated by spaces or hyphens
 * @param {Event} event - The input event
 * @param {Function} setValue - Function to update the value (e.g., (val) => form.value.firstname = val)
 */
export const formatFirstname = (event, setValue) => {
    const input = event.target
    const cursorPosition = input.selectionStart
    const formatted = formatFirstnameValue(input.value)

    setValue(formatted)

    // Restore cursor position
    setTimeout(() => {
        input.setSelectionRange(cursorPosition, cursorPosition)
    }, 0)
}

/**
 * Formats the position with lowercase and ucfirst
 * @param {Event} event - The input event
 * @param {Function} setValue - Function to update the value (e.g., (val) => form.value.position = val)
 */
export const formatPosition = (event, setValue) => {
    const input = event.target
    const cursorPosition = input.selectionStart
    const formatted = formatPositionValue(input.value)

    setValue(formatted)

    // Restore cursor position
    setTimeout(() => {
        input.setSelectionRange(cursorPosition, cursorPosition)
    }, 0)
}
